const baseFontSize = 1.25

// theme.js
export default {
  breakpoints: [`576px`, `768px`, `992px`, `1200px`, `1400px`, `1700px`],
  baseFontSize: baseFontSize,
  fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
  fontFamily: `Inter UI, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
  fontFamilySans: `Larsseit  -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
  fontFamilyHeadings: `'Larsseit, Helvetica Neue', sans-serif`,
  headings: {
    h1: `${baseFontSize * 3.75}rem`,
    h2: `${baseFontSize * 1.75}rem`,
    h3: `${baseFontSize * 1}rem`,
    h4: `${baseFontSize * 1}rem`,
    h5: `${baseFontSize * 0.85}rem`,
    h6: `${baseFontSize * 0.65}rem`,
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  spaceDefault: 16,
  gridGutter: 16,
  colors: {
    blue: `#07c`,
    red: `#d71f43`,
    magenta: `#EA1946`,
    green: `#b9de31`,
    turquoise: `#02E1E3`,
    yellow: `#f5ba88`,
    white: `#fff`,
    grays: {
      '4': `#666`,
      '5': `#808080`,
      '6': `#666`,
      '7': `#4d4d4d`,
      '8': `#333`,
      '9': `#1a1a1a`,
      '0': `#101010`,
    },
  },
}
